export default __webpack_public_path__ + "static/media/3.593eaba4.jpg";